import { render, staticRenderFns } from "./FiltersDialog.vue?vue&type=template&id=51ffb010&"
import script from "./FiltersDialog.vue?vue&type=script&lang=ts&"
export * from "./FiltersDialog.vue?vue&type=script&lang=ts&"
import style0 from "./FiltersDialog.vue?vue&type=style&index=0&id=51ffb010&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports